// JsFromRoutes CacheKey 5469f4b4813d4fb6459d3078fc5c6639
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/employers/verification/owner_invitation'),
  employersVerificationOwnerInvitationApp: /* #__PURE__ */ definePathHelper('get', '/employers/verification/owner_invitation/*path'),
}
